import qs from 'querystringify'
import remote from './remote'

const URL = {
    ADD: '/cms/led',
    SEARCH: '/cms/led',
    DELETE: '/cms/led',
    UPDATE: '/cms/led'
}

export default {
    ledAdd (led, uploadProgressHandler) {
        return remote.request({
            url: remote.getUrl(URL.ADD),
            method: remote.METHOD.POST,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: led,
            timeout: 3600000,
            onUploadProgress: uploadProgressHandler
        })
    },
    updateLed (contentId, led, uploadProgressHandler) {
        return remote.request({
          url: remote.getUrl(URL.UPDATE) + '/' + contentId,
          method: remote.METHOD.POST,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          data: led,
          timeout: 3600000,
          onUploadProgress: uploadProgressHandler,
        });
    },
    searchLed (option) {
        let url = remote.getUrl(URL.SEARCH)

        if (option) {
            url = url + '?' + qs.stringify(option)
        }

        return remote.request({
            url: url,
        })
    },
    searchLedDetail (contentId) {
        return remote.request({
            url: remote.getUrl(URL.SEARCH) + '/' + contentId,
        })
    },
    removeLed (contentId) {
        return remote.request({
            url: remote.getUrl(URL.DELETE),
            method: remote.METHOD.DELETE,
            headers: {
                'Content-Type': 'application/json'
            },
            data: Array.isArray(contentId) ? contentId : [contentId],
        })
    }
}
